import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer"
import './doc-viewer.css'

const uri = "https://engrave-designer-frontend-docs.s3.eu-central-1.amazonaws.com/Podm%C3%ADnky+ochrany+osobn%C3%ADch+%C3%BAdaj%C5%AF_Urnyo.docx"

export const Privacy = () => {
  return (
    <DocViewer config={{ header: { disableHeader: true } }} pluginRenderers={DocViewerRenderers} style={{ height: document.documentElement.clientHeight-56, width: '100%' }} documents={[{ uri: uri, fileType: 'docx' }]} />
  )
}